import { createSelector } from '@reduxjs/toolkit';
import { StoreState } from '../store';
import { SupportedModelType } from '../appConfig/appDeploymentInfoTypes';
import { appConfigSelectors } from '../appConfig/appConfigSlice';
import { configurationTargetSelectors } from './configurationTargetSlice';

/**
 * Selector that returns the intersection of supported model types between the current configuration target
 * and the app deployment. This ensures that only model types that are supported by both the configuration
 * target's license and the app deployment's configuration are returned.
 */
export const selectIntersectionOfSupportedModelTypes = createSelector(
    [configurationTargetSelectors.selectSupportedModelTypes, appConfigSelectors.selectAppDeploymentInfo],
    (targetSupportedModelTypes, appDeploymentInfo): SupportedModelType[] => {
        if (!targetSupportedModelTypes || !appDeploymentInfo) {
            return [];
        }

        // Return the intersection of both sets of supported model types
        return targetSupportedModelTypes.filter(modelType => 
            appDeploymentInfo.supportedModelTypes.includes(modelType)
        );
    }
);
